<template>
  <div class="content">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="header-box" style="color:#4C9AFF;display: flex;align-items: center;" >
          <el-page-header @back="goBack" content="工资申报"></el-page-header>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main
        style="height: 100%;padding:0px !important;  position: relative;width: 100%;"
        class="aside"
      >
        <el-card style="height:100% !important;">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <span>选择月份：</span>
              <el-date-picker
                type="month"
                placeholder="选择日期"
                v-model="search.applyMonth"
                value-format="yyyy-MM"
                @change="doFilter"
              ></el-date-picker>
              <p
                class="font-color2"
                style="padding:10px 20px;font-size:16px;margin:0;margin-left:30px;"
              >计算出勤天数：</p>
              <p style="position: relative;margin-left:5px;">
                <el-select v-model="search.longTime" @change="doFilter" placeholder="请选择">
                  <el-option
                    v-for="item in hours"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <span
                  style="position: absolute;left: 10px;top: 10px;font-size: 14px;color: #8e8888;"
                >出勤大于</span>
              </p>
              <p class="font-color2" style="padding:10px 20px;font-size:16px;margin:0;">小时为1天出勤</p>
            </div>
            <div style="display:flex;align-items:center;width: 10%;justify-content: space-between;">
              <!-- <el-button type="success" @click="exportOut" style="margin-right:10px;">导出模板</el-button> -->
                <el-tooltip class="item" effect="dark" content="导出表" placement="top-end">
                    <img  @click="exportOut" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="">
                </el-tooltip>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="uploadHead"
                :data="uploadData"
                :show-file-list="false"
                :on-success="handleAppSuccess"
              >
                <!-- <el-button type="primary" icon="el-icon-upload">导入工资表</el-button> -->
                  <el-tooltip class="item" effect="dark" content="导入表" placement="top-end">
                    <img  class="icon_hover" src="../../assets/image/import.png" alt="" srcset="">
                </el-tooltip>
              </el-upload>
            </div>
          </div>
          <!--  -->
          <div class="build-table">
            <div
              style="width:100%;border-top:1px solid #f5f5f5;border-bottom:6px solid #f5f5f5"
              class="info"
            >
              <div class="bar-item">
                <p style="width:25%;">项目名称：{{proInfo.name}}</p>
                <p style="width:25%;">许可证编号：{{proInfo.permit}}</p>
                <p style="width:25%;">合同总价：{{proInfo.price}}万元</p>
                <p style="width:25%;">建筑面积：{{proInfo.areas}}平方</p>
              </div>
              <div class="bar-item" style="flex-wrap: wrap;">
                <p style="width:33%;">建设单位：{{proInfo.entName}}</p>
                <p style="width:33%;">总包单位：{{proInfo.constructionName}}</p>
                <p style="width:33%;">监理单位：{{proInfo.supervisionName}}</p>
                <p style="width:33%;">社会统一码：{{proInfo.entCredit}}</p>
                <p style="width:33%;">社会统一码：{{proInfo.constructionCredit}}</p>
                <p style="width:33%;">社会统一码：{{proInfo.supervisionCredit}}</p>
              </div>
              <div class="bar-item">
                <p style="width:33%;">专户账号：{{proInfo.accountCapital}}</p>
                <p style="width:33%;">开户行：{{proInfo.bankBranch}}</p>
              </div>
            </div>
            <!-- 循环表格 -->
            <div v-for="item in listData" :key="item.teamsId" style="width:100% !important">
              <p
                style="width:100%;height:36px;color:#fff;background:#3a8ee6;display:flex;align-items: center;padding:0 20px;"
              >{{item.teamsName}}</p>
              <div class="box-content" style="width:100%">
                <el-table :data="item.list" border stripe style="width: 98%;">
                  <template slot="empty">
                    <p>{{dataText}}</p>
                  </template>
                  <el-table-column label="序号" width="60" type="index"></el-table-column>
                  <el-table-column label="姓名">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="身份证">
                    <template slot-scope="scope">
                      <span>{{ scope.row.idCard }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="银行卡号">
                    <template slot-scope="scope">
                      <span>{{ scope.row.bankCard }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="行号">
                    <template slot-scope="scope">
                      <span>{{ scope.row.lineNumber }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="合同工资">
                    <template slot-scope="scope">
                      <span>{{ scope.row.cashContract }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="出勤天数">
                    <template slot-scope="scope">
                      <span>{{ scope.row.countNum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="应发工资">
                    <template slot-scope="scope">
                      <span>{{ scope.row.paymentSalary }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="实发工资">
                    <template slot-scope="scope">
                      <span>{{ scope.row.mustPaymentSalary }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注">
                    <template slot-scope="scope">
                      <span>{{ scope.row.note }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="操作">
                             <template slot-scope="scope">
                                 <el-button type="text" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                             </template>
                  </el-table-column>-->
                </el-table>
              </div>
              <div class="box-content-item">
                <p class="cell">施工企业意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">施工企业盖章</p>
              </div>
              <div class="box-content-item">
                <p class="cell">监理公司现场监理部意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">监理公司盖章</p>
              </div>
              <div class="box-content-item">
                <p class="cell">建设管理中心意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">建设管理单位盖章</p>
              </div>
            </div>
            <div class="box-content-item wrap" style="padding:50px;">
              <div class="row" style="text-align:center;">
                <el-button type="success" @click="goBack">返回</el-button>
                <el-button type="primary" @click="subWage(1)" style="margin-left:50px;">确认提交</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <!--  -->
    <el-dialog title="选择审批人" :visible.sync="dialogVisible" width="30%">
      <div style="height: 300px;display:flex;">
        <el-steps direction="vertical" :active="0" style="width:150px;">
          <el-step title="施工单位" description="请选择审批人"></el-step>
          <el-step title="监管单位" description="请选择审批人"></el-step>
          <el-step title="建设单位" description="请选择审批人"></el-step>
        </el-steps>
        <div style="flex:1;">
          <!-- 施工单位 -->
          <div class="selectd-item">
            <div class="selectd-item-person" v-for="(item , index) in workPerson" :key="item.id">
              <p class="person-name">{{item.name}}</p>
              <span class="person-workerType">{{item.workTypeName}}</span>
              <p class="person-del" @click="delPerson(0,item.id)">
                <i class="el-icon-close" style="font-size: 12px;"></i>
              </p>
              <p class="person-right" v-if="index < 2">
                <i class="el-icon-arrow-right" style="font-size: 20px;color: #635f5f;"></i>
              </p>
            </div>
            <div class="person-add" v-if="workPerson.length < 3 ">
              <p class="person-add-crol" @click="addPersonFun(0)">
                <i class="el-icon-plus" style="font-size: 26px;"></i>
              </p>
              <span style="width:100%;height:30px;text-align: center;"></span>
            </div>
          </div>
          <!-- 监管单位 -->
          <div class="selectd-item">
            <div class="selectd-item-person" v-for="item in superPerson" :key="item.id">
              <p class="person-name">{{item.name}}</p>
              <span class="person-workerType">{{item.workTypeName}}</span>
              <p class="person-del" @click="delPerson(1,item.id)">
                <i class="el-icon-close" style="font-size: 12px;"></i>
              </p>
              <p class="person-right">
                <i class="el-icon-arrow-right" style="font-size: 20px;color: #635f5f;"></i>
              </p>
            </div>
            <div class="person-add">
              <p class="person-add-crol" @click="addPersonFun(1)">
                <i class="el-icon-plus" style="font-size: 26px;"></i>
              </p>
              <span style="width:100%;height:30px;text-align: center;"></span>
            </div>
          </div>
          <!-- 建设单位 -->
          <div class="selectd-item">
            <div class="selectd-item-person" v-for="item in buildPerson" :key="item.id">
              <p class="person-name">{{item.name}}</p>
              <span class="person-workerType">{{item.workTypeName}}</span>
              <p class="person-del" @click="delPerson(2,item.id)">
                <i class="el-icon-close" style="font-size: 12px;"></i>
              </p>
              <p class="person-right">
                <i class="el-icon-arrow-right" style="font-size: 20px;color: #635f5f;"></i>
              </p>
            </div>
            <div class="person-add">
              <p class="person-add-crol" @click="addPersonFun(2)">
                <i class="el-icon-plus" style="font-size: 26px;"></i>
              </p>
              <span style="width:100%;height:30px;text-align: center;"></span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
      <el-dialog
        width="30%"
        title="审批人"
        :visible.sync="innerVisible"
        custom-class="inner-dialog"
        append-to-body
      >
        <el-table
          ref="multipleTable"
          :data="approveList"
          tooltip-effect="dark"
          style="width: 100%"
          @row-click="toStaffDetail"
          @select="userChoose"
        >
          <el-table-column type="selection"></el-table-column>
          <!-- 循环展示表头 -->
          <template v-for="(col) in tableHeaderData">
            <el-table-column :prop="col.dataProp" :label="col.dataName" :key="col.dataProp"></el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="selPerson">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 导入弹出框 -->
       <el-dialog
            :title="dialogTitle1"
            :visible.sync="imoportVisible"
            center
            :append-to-body="true"
            :before-close="handleClose1"
            :lock-scroll="false"
            width="30%"
          >
            <template>
              <el-table :data="tableData1" style="width: 100%" border>
                <el-table-column label="状态" width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0">
                      <i class="el-icon-circle-check" style="color:#07C160"></i>
                    </span>
                    <span v-if="scope.row.status==1">
                      <i class="el-icon-warning-outline" style="color:#f00"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.result}}</span>
                    <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.result}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-dialog>
  </div>
</template>
<script>
import util from '../../untils/util'
import base from '../../untils/base'
import myHttp from '../../untils/port'
export default {
  data() {
    return {
      search: {
        applyMonth: util.myTime.getCurMonth(),
        longTime: 0
      },
      listData: [],
      groupId: '',
      // num:{
      //     money:0,
      //     person:0
      // },
      uploadUrl: myHttp.importTeamsPersonSalaryList, //上传地址
      uploadHead: {
        accessToken: this.$store.state.token
      },
      uploadData: {
        monthTime: '',
        projectId: '',
        longTime:'',
      },
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      hours: [
        { id: '0', name: 0 },
        { id: '1', name: 1 },
        { id: '2', name: 2 },
        { id: '3', name: 3 },
        { id: '4', name: 4 },
        { id: '5', name: 5 },
        { id: '6', name: 6 },
        { id: '7', name: 7 },
        { id: '8', name: 8 }
      ],
      dialogVisible: false, //弹出框显示
      innerVisible: false, //嵌套弹出框显示
      tableHeaderData: [
        //选择人列表标题
        { dataProp: 'index', dataName: '序号' },
        { dataProp: 'name', dataName: '姓名' },
        { dataProp: 'workTypeName', dataName: '岗位' },
        { dataProp: 'typeName', dataName: '单位类型' }
      ],
      approveList: [
        //当前可选择人列表
      ],
      curApprPerson: {}, //当前选择人
      unitType: 0, //当前选择单位类型 0：施工单位    1：监管单位    2：建设单位
      workPerson: [], //施工审批人
      superPerson: [], //监管审批人
      buildPerson: [], //建设审批人
      proInfo: {}, //项目信息
      imoportVisible:false,
      dialogTitle1:'导入结果',
        tableData1:[]
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.uploadData.projectId = this.groupId
    this.uploadData.monthTime = this.search.applyMonth
     this.uploadData.longTime = this.search.longTime
    this.getData()
    this.getProInfo()
  },
  methods: {
    doFilter() {
      this.uploadData.monthTime = this.search.applyMonth
      this.getData()
    },
    //  handleSizeChange(val) {
    //     this.pageSize = val
    //     this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //     this.currentPage = val
    //     this.currentChangePage();
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //     this.getData();
    // },
    //点击过滤
    // showProjectFun(index){
    //     this.search.unit = index
    //     this.getData()
    // },
    //获取数据
    getData() {
      var that = this
      this.search.projectId = this.groupId
      // myHttp.getSalaryApplyDetailList(this.search).then(function(resp){
      //     if(resp.data.code=='200'){
      //         var list = resp.data.data.applyDetail;
      //         var num = {money:0,person:list.length};
      //         for(var i=0;i<list.length;i++){
      //             list[i].monthSalary = list[i].monthSalary?list[i].monthSalary:0;
      //             num.money += parseFloat(list[i].monthSalary)
      //         }
      //         num.money = num.money.toFixed(2);
      //         that.listData = list;
      //         that.num = num;
      //         if(that.listData.length==0){
      //             that.dataText = "暂无数据"
      //         }
      //     }else{
      //         that.dataText = "暂无数据"
      //     }
      // })
      myHttp
        .findAllTeamsPersonList({
          projectId: this.groupId,
          time: this.search.applyMonth,
          longTime: this.search.longTime,
          name: ''
        })
        .then(function(resp) {
          if (resp.data.code == 200) {
            var list = resp.data.data.list || []
            var montDay = parseInt(
              util.myTime.getMonthDay(that.search.applyMonth)
            )
            for (var i = 0; i < list.length; i++) {
              for (var j = 0; j < list[i].list.length; j++) {
                if (
                  list[i].list[j].cashContract &&
                  list[i].list[j].cashContract != '' &&
                  list[i].list[j].cashContract != 0
                ) {
                  list[i].list[j].shouldSalary =
                    (parseFloat(list[i].list[j].cashContract) / montDay) *
                    parseInt(list[i].list[j].countNum)
                } else {
                  list[i].list[j].shouldSalary = 0
                }
              }
            }
            that.listData = list
            that.dataText = '暂无数据'
          } else {
            that.dataText = '暂无数据'
          }
        })
    },
    //获取项目信息
    getProInfo() {
      var that = this
      myHttp
        .findProjectInfo({
          projectId: this.groupId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.proInfo = resp.data.data.result
            // var data = resp.data.data.entity
            // if(that.search.unit==1){
            //     var obj = data.jsdw[0]
            //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
            //     that.num = obj
            // }else if(that.search.unit==2){
            //     var obj = data.sgdw[0]
            //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
            //     that.num = obj
            // }else{
            //     var obj = data.jldw[0]
            //     obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
            //     that.num = obj
            // }
          }
        })
    },
    //导出
    exportOut() {
      var token = this.$store.state.token
      console.log(myHttp.exportTeamsPersonSalaryList)
      window.open(
        myHttp.exportTeamsPersonSalaryList +
          '?projectId=' +
          this.groupId +
          '&monthTime=' +
          this.search.applyMonth +
          '&longTime=' +
          this.search.longTime +
          '&accessToken=' +
          token
      )
      // window.open(myHttp.exportSalaryDetail+'?projectId='+this.groupId+'&applyMonth='+this.search.applyMonth+'&accessToken='+token)
    },
    //导入
    exportIn() {},
    //查看
    // handleEdit(index,row){
    //     this.$router.push('/checkDetail/'+row.id+'/'+row.type)
    // },
    //返回
    goBack() {
      this.$router.go(-1)
    },
    //提交
    subWage(index) {
      var that = this
     
      if(this.listData.length==0){
        this.$message.error('没有数据无法提交')
        return
      }
       var applyFormId = that.listData[0].applyFormId
      myHttp
        .commitSalaryApply({
          applyMonth: this.search.applyMonth,
          projectId: this.groupId,
          applyFormId: applyFormId,
          userId: util.session.get('user').id,
          status:index
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.$router.go(-1)
            that.$message.success('提交成功')
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },

     /**
     * 导入上传成功监听方法
     */
    handleAppSuccess(res, file) {
      if (res.code == '200') {
        this.tableData1 = res.data
        this.imoportVisible = true
        this.$message.success(res.msg)
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     *
     */
    userChoose(selection, row) {
      //clearSelection：用于多选表格，清空用户的选择
      //此时所有的checkbox处于未勾选，当用户第一次点击的时候，selectio为一个数组，里面存放的为当前这一行的数据
      this.curApprPerson = row
      this.$refs.multipleTable.clearSelection()
      //此时selection仍然有值 ，只是勾选状态不显示了。
      if (selection.length === 0) {
        return
      }
      //这这里将这行的状态又变为了勾选
      this.$refs.multipleTable.toggleRowSelection(row, true)
      //用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
    },
    toStaffDetail(row, column, event) {
      // console.log(row,column,event)
      // console.log(this.multipleSelection)
      this.userChoose([row], row)
    },
    /**
     * 点击保存当前选择人
     */
    selPerson() {
      if (!this.curApprPerson) {
        this.$message.error('请选择审批人！')
        return
      }
      if (this.unitType == 0) {
        this.workPerson.push(this.curApprPerson)
      } else if (this.unitType == 1) {
        this.superPerson.push(this.curApprPerson)
      } else if (this.unitType == 2) {
        this.buildPerson.push(this.curApprPerson)
      }
      this.innerVisible = false
    },
    /**
     * 删除人员
     */
    delPerson(type, id) {
      if (type == 0) {
        this.workPerson = this.filterPersonList(id, this.workPerson)
      } else if (type == 1) {
        this.superPerson = this.filterPersonList(id, this.superPerson)
      } else if (type == 2) {
        this.buildPerson = this.filterPersonList(id, this.buildPerson)
      }
    },
    filterPersonList(id, list) {
      var result = []
      for (var i = 0; i < list.length; i++) {
        if (id != list[i].id) {
          result.push(list[i])
        }
      }
      return result
    },
    /**
     * 添加审批人
     */
    addPersonFun(type) {
      this.unitType = type
      this.curApprPerson = undefined
      this.innerVisible = true
      this.getPersonList(type)
      this.$refs.multipleTable.clearSelection()
    },
    /**
     * 根据类型获取列表
     */
    getPersonList(type) {},
    handleClose1(){
      this.imoportVisible =false
    },
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px;
  height: 40px;
  align-items: center;
  font-size: 16px;
  justify-content: space-between;
}
.content >>> .el-input--suffix .el-input__inner {
  padding-right: 30px;
  text-align: right;
}
.build-table {
  height: calc(100% - 80px);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  overflow: auto;
}
.bar-item {
  width: 100%;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.bar-item p {
  margin: 5px 0;
  text-align: left;
}
.box-content {
  width: 100%;
  /* height: 50%; */
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  border-top: 6px solid #f5f5f5;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
/* .content >>> .el-page-header__content {
  font-size: 14px !important;
  color: #303133;
} */
</style>